'use strict';

// ----------------------------------------
// Private
// ----------------------------------------
let electric = true;
let usa = true;
let unbroken = true;
let $calculator = $('.calculator-form');
let $calculatorResults = $('.calculator__results-wrap');
let $autoCostOutput = $('#price-output');
let $autoTotalOutput = $('#total-output');
let $ndsOutput = $('#nds-output');
let $dutyOutput = $('#duty-output');
let $exciseOutput = $('#excise-output');
let $customsTotalOutput = $('#customs-total-output');
let $deliveryOutput = $('#delivery-output');
let $brokerOutput = $('#broker-output');
let $certificateOutput = $('#certificate-output');
let $deliveryTotalOutput = $('#delivery-total-output');
let $autoCostInput = $('#auto-price-input');
let $engineInput = $('#auto-engine-input');
let $submitBtn = $('.calculator-submit-btn');
let $resetBtn = $('.calculator-reset-btn');
let $electricWrap = $('.calculator__results--electric');
let $gasWrap = $('.calculator__results--gas');
let $fuelInput = $('#fuel-select');
let $countryInput = $('#country-select');
let $stateInput = $('#state-select');
let ndsTotal;
let dutyTotal;
let exciseTotal;
let customsTotal;
let autoCost;
let autoTotalCost;
let engineValue;
let brokenCustomTotal;
let deliveryCost = $electricWrap.data('delivery');
let brokerCost = $electricWrap.data('broker');
let certificateCost = $electricWrap.data('certificate');
let ndsValue = $gasWrap.data('nds');
let dutyValue = $gasWrap.data('duty');
let exciseValue = $gasWrap.data('excise');
let referenceCost = $gasWrap.data('reference');
let deliveryEuroCost = $gasWrap.data('delivery-euro');
let deliveryUsaCost = $gasWrap.data('delivery-usa');
let deliveryTotal;

// Thousand separator

function setThousands (numberText, newSeparator, separator) {
	newSeparator = newSeparator || '.';
	separator = separator || '.';
	numberText = '' + numberText;
	numberText = numberText.split(separator);

	let numberPenny = numberText[1] || '';
	let numberValue = numberText[0];

	let thousandsValue = [];
	let counter = 0;

	for (let i = numberValue.length - 1; i >= 0; i--) {
		let num = numberValue[i];
		thousandsValue.push(num);

		if (++counter === 3 && i) {
			thousandsValue.push(' ');
			counter = 0;
		}
	}

	thousandsValue = thousandsValue.reverse().join('');
	if (numberPenny.length) {
		return [thousandsValue, numberPenny].join(newSeparator);
	}
	return thousandsValue;
}

function calculateResults (value) {
	// get values
	$autoCostInput.on('change', function () {
		autoCost = $(this).val();

		console.log(autoCost);
	});

	$engineInput.on('change', function () {
		engineValue = $(this).val();

		console.log(engineValue);
	});

	// calculate values
	autoCost = parseInt(autoCost);
	engineValue = parseInt(engineValue);
	deliveryTotal = (deliveryCost + brokerCost + certificateCost);

	dutyTotal = Math.floor((autoCost * dutyValue) / 100);
	exciseTotal = Math.floor(engineValue * exciseValue);
	ndsTotal = Math.floor((autoCost + dutyTotal + exciseTotal + referenceCost + (usa ? deliveryUsaCost : deliveryEuroCost)) * ndsValue);
	customsTotal = Math.floor(dutyTotal + exciseTotal + ndsTotal);
	brokenCustomTotal = customsTotal - ((customsTotal * 20) / 100);

	autoTotalCost = autoCost + (electric ? deliveryTotal : customsTotal);
}

function setResults () {
	calculateResults();

	// append values on the page
	$autoCostOutput.text(setThousands(autoCost) + ' $');
	$autoTotalOutput.text(setThousands(autoTotalCost) + ' $');

	if (electric) {
		$deliveryOutput.text(setThousands(deliveryCost) + ' $');
		$brokerOutput.text(setThousands(brokerCost) + ' $');
		$certificateOutput.text(setThousands(certificateCost) + ' $');
		$deliveryTotalOutput.text(setThousands(deliveryTotal) + ' $');
	} else {
		$ndsOutput.text(setThousands(ndsTotal) + ' $');
		$dutyOutput.text(setThousands(dutyTotal) + ' $');
		$exciseOutput.text(setThousands(exciseTotal) + ' $');
		$customsTotalOutput.text(setThousands(unbroken ? customsTotal : brokenCustomTotal) + ' $');
	}

	if (!electric) {
		$electricWrap.addClass('_hide');
		$gasWrap.removeClass('_hide');
	} else {
		$gasWrap.addClass('_hide');
		$electricWrap.removeClass('_hide');
	}

	$calculatorResults.slideDown('slow');
	$submitBtn.addClass('hidden');
}

// ----------------------------------------
// Public
// ----------------------------------------

function onlineCalculator () {
	if (!$calculator.length) {
		return false;
	}

	$engineInput.attr(electric ? 'readonly' : 'required', true);

	$autoCostInput.on('change', function () {
		autoCost = $(this).val();
	});

	$engineInput.on('change', function () {
		engineValue = $(this).val();
	});

	$fuelInput.on('select2:select', function () {
		let value = $(this).val();

		electric = value === 'electric';

		$engineInput
			.removeAttr(electric ? 'required' : 'readonly')
			.attr(electric ? 'readonly' : 'required', true);
	});

	$countryInput.on('select2:select', function () {
		let value = $(this).val();

		usa = value === 'usa';
	});

	$stateInput.on('select2:select', function () {
		let value = $(this).val();

		unbroken = value === 'unbroken';
	});

	$resetBtn.on('click', function () {
		$calculatorResults.slideUp('slow');
		$calculator.trigger('reset');
		$submitBtn.removeClass('hidden');
	});

	$('.calculator__to-catalog').on('click', function () {
		$calculator.trigger('reset');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {onlineCalculator, setResults};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/online-calculator.js